"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_query_1 = require("@tanstack/react-query");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const components_1 = require("@/common/components");
const _1 = require(".");
function default_1({ leaderChannelId }) {
    const { data, fetchNextPage, isFetchingNextPage } = (0, react_query_1.useInfiniteQuery)(['reviewContentsData'], ({ pageParam: pageUrl = '' }) => __awaiter(this, void 0, void 0, function* () {
        const res = yield (0, api_1.getData)(pageUrl || `/api/v1/profile/${leaderChannelId}/review`);
        return res.data;
    }), {
        getNextPageParam: data => { var _a; return (_a = data.meta.next) !== null && _a !== void 0 ? _a : undefined; },
        cacheTime: 0,
        refetchOnWindowFocus: false,
    });
    const getRenderData = () => {
        if (data)
            return data.pages.flatMap(obj => obj.result);
        else
            return [];
    };
    const renderData = (0, react_1.useMemo)(getRenderData, [data]);
    const hasRenderData = !!renderData.length;
    const whoAmI = (0, react_redux_1.useSelector)((state) => state.whoAmI);
    const isMyRoom = leaderChannelId === whoAmI.id;
    const isAdmin = whoAmI.is_admin;
    const { t } = (0, react_i18next_1.useTranslation)();
    if (!hasRenderData)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: { display: 'flex', flexDirection: 'column', rowGap: '14px', padding: '20px 16px 40px' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle3 gray-80" }, { children: t('전체 리뷰') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '30px' } }, { children: renderData.map(reviewContent => ((0, jsx_runtime_1.jsx)(_1.ReviewContent, { reviewContent: reviewContent, isMyRoom: isMyRoom, isAdmin: isAdmin }, `review_content_${reviewContent.id}`))) })), (0, jsx_runtime_1.jsx)(components_1.InfiniteScroller, { fetchNextPage: fetchNextPage, isFetchingNextPage: isFetchingNextPage, hasRenderData: true })] })));
}
exports.default = default_1;
